import { parseHtmlWithHighlight, toWebp } from "@/utils/common";
import Image from "next/image";
import RfpMiniForm from "../rfp-mini-form";
import HeroMobile from "./mobile-hero";
import StickyHeader from "../sticky-header";

const baseUrl = process.env.NEXT_PUBLIC_REACT_APP_RESOURCE_BASE_URL ?? "";

interface HeroProps {
  data?: any;
}

export default function Hero({ data }: HeroProps) {
  const portraitUrl = data?.image?.data?.attributes?.url;
  const bannerCards = data?.bannerCard || [];
  const bannerAnimationUrl = data?.banner_animation?.data?.attributes?.url;
  const heroBgImage = bannerAnimationUrl
    ? toWebp(`${baseUrl}${bannerAnimationUrl}`)
    : "/images/clutch-landing/banner.png";

  return (
    <>
      <StickyHeader
        watchIds={["lp-hero", "lp-hero-mobile"]}
        targetFieldId="full_name"
      />

      <section
        id="lp-hero"
        className="relative  overflow-hidden bg-black pt-[56px] xl:pb-[0] lg:pb-[0] pb-[56px] z-0 md:block hidden"
        style={{
          backgroundImage: `url('${heroBgImage}')`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          // marginTop: "var(--df-banner-offset, 0px)",
        }}
      >
        {/* Overlay */}
        <div className="absolute inset-0 bg-black/60 z-[-1]" />
        <div className="container z-10">
          <Image
            src="/images/clutch-landing/logo.svg"
            alt="TRooTech Logo"
            width={180}
            height={54}
            className="lg:min-w-[167px] min-w-[167px]"
          />

          {data?.sub_title && (
            <p className="mt-[20px] mb-[60px] xl:text-[18px] xl:leading-[25.2px] text-[16px] leading-[22.4px] uppercase tracking-[1px] text-white">
              {data.sub_title}
            </p>
          )}

          <div className="hero-c-grid">
            <div>
              <h1 className="hero-main-head lg:!text-[40px] lg:!leading-[1.25]">
                {parseHtmlWithHighlight(data?.banner_title)}
              </h1>
              {data?.description && (
                <p className="xl:text-[18px] xl:leading-[25.2px] text-[16px] leading-[22.4px] tracking-[1px] text-white mb-[20px] font-regular">
                  {data.description}
                </p>
              )}

              <div className="flex gap-[20px] xl:pb-[48px] lg:pb-[80px]">
                {bannerCards.map((card: any, idx: number) => {
                  const badgeUrl = card?.image?.data?.attributes?.url;
                  if (!badgeUrl) return null;

                  return (
                    <Image
                      key={idx}
                      src={toWebp(`${baseUrl}${badgeUrl}`)}
                      alt={`Clutch badge ${idx + 1}`}
                      width={80}
                      height={86}
                      className="object-contain w-[81px] h-[86px]"
                      unoptimized
                      quality={100}
                    />
                  );
                })}
              </div>
            </div>

            {/* CENTER IMAGE */}

            {portraitUrl && (
              <div className="hidden xl:flex justify-center mt-auto xl:w-full w-[40%]">
                <Image
                  src={toWebp(`${baseUrl}${portraitUrl}`)}
                  alt="Portrait"
                  width={452} // Adjust to your image's actual width
                  height={646} // Adjust to your image's actual height
                  className="main-head-image object-contain pointer-events-none "
                />
              </div>
            )}

            {/* FORM */}
            <div className="bg-[url(/images/Quote-bg.webp)]  bg-no-repeat bg-cover bg-center  h-fit  mb-[50px]">
              <RfpMiniForm
                heading={data?.rfp_title || "Request for Proposal"}
                className="p-[32px_24px] h-full"
              />
            </div>
          </div>
          {/* FORM */}
        </div>
      </section>

      <HeroMobile data={data} />
    </>
  );
}
